import { UserActivity as User } from '@models/user-activity.model';
import {
  generateAvatarBackgroundColorClassName,
  getAvatarUrl,
} from '@modules/test-development/utils/avatar-class-utils';
import {
  Avatar,
  DateTimeFormat,
  ShimmerLoader,
  TooltipPlacement,
  TruncatedText,
} from '@testsigma/atoms';
import classNames from 'classnames';
import React from 'react';

interface UserActivityProps {
  user?: User;
  date?: Date;
  className?: string;
  avatarClassName?: string;
  nameClassName?: string;
  tooltipPlacement?: TooltipPlacement;
}

const UserActivity: React.FC<UserActivityProps> = ({
  user,
  date,
  className,
  nameClassName,
  avatarClassName,
  tooltipPlacement = 'bottom',
}) => {
  const userFullName = user?.name
    ? user.name
    : `${user?.firstName} ${user?.lastName}`;
  const avatarClass = generateAvatarBackgroundColorClassName(userFullName);

  return (
    <div className={`flex gap-2 items-center ${className}`}>
      {user ? (
        <span className='flex shrink-0'>
          <Avatar
            alt={userFullName}
            shape='circle'
            size='sm'
            className={classNames(avatarClass, avatarClassName)}
            src={getAvatarUrl(user)}
          />
        </span>
      ) : (
        <ShimmerLoader type='circle' size='sm' />
      )}
      <div className='flex flex-col w-full overflow-hidden pr-3'>
        {user ? (
          <>
            <TruncatedText
              className={classNames('leading-4', nameClassName)}
              value={userFullName}
              toolTipPlacement={tooltipPlacement}
            />
            {date ? (
              <div className='truncate text-xxs font-normal leading-3.5 text-secondary-500'>
                <DateTimeFormat date={date} format='MMM d, yyyy' />
              </div>
            ) : null}
          </>
        ) : (
          <>
            <ShimmerLoader type='line' className='!h-4 mb-2' />
            <ShimmerLoader type='line' className='!h-4' />
          </>
        )}
      </div>
    </div>
  );
};

export default UserActivity;
